import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { Produtividade, RepresentanteKPIFilter, ModalidadeComercialFaturamento } from '../adapters';
import { REPRESENTANTES_PRODUTIVIDADE_KPIS_API_RESOURCE, REPRESENTANTES_MODALIDADES_COMERCIAIS_KPIS_API_RESOURCE } from '../consts';

@Injectable({
    providedIn: 'root'
})
export class RepresentanteKPIsHttpService {
    /** API dos KPIs de produtividade dos representantes */
    private readonly apiProdutividade: string;
    /** API dos KPIs das modalidades comerciais */
    private readonly apiModalidadesComerciais: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.apiProdutividade = `${configServerService.getKPIsAPIResource()}/${REPRESENTANTES_PRODUTIVIDADE_KPIS_API_RESOURCE}`;
        this.apiModalidadesComerciais = `${configServerService.getKPIsAPIResource()}/${REPRESENTANTES_MODALIDADES_COMERCIAIS_KPIS_API_RESOURCE}`;
    }

    /** Carrega os KPIs de produtividade dos representantes */
    getProdutividade(filter: RepresentanteKPIFilter): Observable<Produtividade> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<Produtividade>(this.apiProdutividade, {params})
                    .pipe(
                        map(response => Produtividade.fromJSON(JSON.stringify(response)))
                    );
    }

    /** Carrega os KPIs de faturamentos das modalidades comerciais */
    getModalidadesComerciaisFaturamento(filter: RepresentanteKPIFilter): Observable<ModalidadeComercialFaturamento> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ModalidadeComercialFaturamento>(`${this.apiModalidadesComerciais}/faturamento`, {params})
                    .pipe(
                        map(response => ModalidadeComercialFaturamento.fromJSON(JSON.stringify(response)))
                    );
    }
}
